import $ from "jquery";
import { MySearchHelper } from "./MySearchHelper.js";
import Swiper from 'swiper/bundle';

export class MainMySearchHelper extends MySearchHelper {
    constructor(searchChangeHelper) {
        super(searchChangeHelper);
        this.loadSearchForMain();
    }

    loadSearchForMain() {
        this.mySearchList = [];
        $.ajax({
            type: 'POST',
            url: `/member/res/favorSearch.php`,
            data: {
                reqCase: 'fv_list',
            },
            dataType: 'JSON',
        }).done((response) => {
            if (!response.item) {
                this.wrapMySearchToSwiper();
                return;
            }
            response.item.forEach((item) => {
                this.mySearchList.push({
                    idx: item.idx,
                    srchDataObject: JSON.parse(item.param),
                    cdtn_nm: item.cdtn_nm,
                    title: item.user_title,
                    wdtm: item.wdtm,
                    srch_cnt: item.cnt,
                });
            });
            this.wrapMySearchToSwiper();
        })
            .fail((jqXHR, textStatus, errorThrown) => {
                const response = jqXHR.responseJSON;
                return;
            });
    }

    wrapMySearchToSwiper() {
        // 반응형: 모바일/PC 분기
        if (window.innerWidth < this.searchChangeHelper.config.responsiveInfo.mobileWidth) {
            this.wrapMySearchToSwiperForMobile();
        } else {
            this.wrapMySearchToSwiperForPC();
        }
    }

    wrapMySearchToSwiperForPC() {
        $("#favoriteCount").text(`(${this.mySearchList.length})`);
        $('.favoriteSwiper').empty();
        let slides = '';
        if (this.mySearchList.length === 0) {
            slides += `
                <div style='width:100%;height:140px;'>
					<div style='padding-top:5px'>
						<div style='background:#FFF;text-align:center;padding:25px;'>
							<div class='center f14 bold_500 p5'>추가한 즐겨찾는 검색이 없습니다.</div>
							<div class='center gray f13'>(나의 즐겨찾는 검색을 추가하시려면 검색 페이지에서 검색 조건 지정 후 조건 저장 버튼을 누르시면 됩니다.)</div>
						</div>
					</div>
				</div>
            `;

        } else {
            this.mySearchList.forEach((item) => {
                slides += `
                    <div class='swiper-slide myfvSlide' data-idx='${item.idx}' data-path='${this.SrchTypeObject[item.srchDataObject.srchData.srchCase].path}'>
                        <div class='BtnMyfv' style='height:100px'>
                            <div style='padding:20px 20px'>
                                <span class='linkTitle'>${this.SrchTypeObject[item.srchDataObject.srchData.srchCase].title}</span>
                                <span class='linkMent'>${item.title}</span>
                            </div>
                        </div>
                    </div>
                `;
            });
            $('.MyfvPrev').show();
            $('.MyfvNext').show();
        }
        if (this.mySearchList.length > 0 && this.mySearchList.length < 6) {
            for (let i = 0; i < 6 - this.mySearchList.length; i++) {
                slides += `
                    <div class='swiper-slide myfvSlide' data-idx='0'>
                        <div class='BtnMyfvNo' style='height:100px'>
                            <div style='padding:35px 0' class='center'>
                                <span class='linkTitle' style='color:#aaa'>즐겨찾는 검색을 추가하면<br> 이곳에 보입니다.</span>
                            </div>
                        </div>
                    </div>
                `;
            }
        }
        $('.favoriteSwiper').append(slides);
        this.setSwiperForPC();

        $('.myfvSlide').on('click', async (e) => {
            const idx = $(e.currentTarget).data('idx');
            if (idx === 0) {
                return;
            }
            const path = $(e.currentTarget).data('path');
            document.location.href = `${path}?mySearch=${idx}`;
        });
    }

    wrapMySearchToSwiperForMobile() {
        $("#favoriteCount").text(`(${this.mySearchList.length})`);
        $('.favoriteSwiper').empty();
        let slides = '';
        
        if (this.mySearchList.length === 0) {
            slides += `
                <div style='width:100%;height:140px;'>
					<div style='padding-top:5px'>
						<div style='background:#FFF;text-align:center;padding:25px;'>
							<div class='center f14 bold_500 p5'>추가한 즐겨찾는 검색이 없습니다.</div>
							<div class='center gray f13'>(나의 즐겨찾는 검색을 추가하시려면 검색 페이지에서 검색 조건 지정 후 조건 저장 버튼을 누르시면 됩니다.)</div>
						</div>
					</div>
				</div>
            `;
        } else {
            this.mySearchList.forEach((item) => {
                slides += `
                    <div class='swiper-slide myfvSlide' data-idx='${item.idx}' data-path='${this.SrchTypeObject[item.srchDataObject.srchData.srchCase].path}'>
                        <div class='BtnMyfv' style='height:100px'>
                            <div style='padding:10px 10px'>
                                <span class='linkTitle'>${this.SrchTypeObject[item.srchDataObject.srchData.srchCase].title}</span>
                                <span class='linkMent'>${item.title}</span>
                            </div>
                        </div>
                    </div>
                `;
            });
            $('.MyfvPrevMobile').show();
            $('.MyfvNextMobile').show();
        }
        
        $('.favoriteSwiper').append(slides);
        this.setSwiperForMobile();

        $('.myfvSlide').on('click', async (e) => {
            const idx = $(e.currentTarget).data('idx');
            if (idx === 0) {
                return;
            }
            const path = $(e.currentTarget).data('path');
            document.location.href = `${path}?mySearch=${idx}`;
        });
    }

    setSwiperForPC() {
        // PC용: 가로 스와이퍼
        let slidesPerView = 6;
        // window.innerWidth 700, 950에 따라 -1
        if (window.innerWidth <= 950 && window.innerWidth > 800) {
            slidesPerView = 5;
        } else if (window.innerWidth <= 800 && window.innerWidth > 700) {
            slidesPerView = 4;
        } else if (window.innerWidth <= 700 && window.innerWidth > 600) {
            slidesPerView = 3;
        } else if (window.innerWidth <= 600) {
            slidesPerView = 2;
        }
        var banner = new Swiper("#MyfvSwiper", {
            slidesPerView: slidesPerView,
            spaceBetween: 20,
            speed: 1000,
            direction: 'horizontal',
            pagination: {
                el: ".MyfvPage",
                clickable: true,
            },
            navigation: {
                nextEl: ".MyfvNext",
                prevEl: ".MyfvPrev"
            },
        });

        $(".MyfvSt").on("click", (e) => {
            this.setWidget(e.target.checked);
        });
    }

    setSwiperForMobile() {
        // 모바일용: 세로 스와이퍼
        var banner = new Swiper("#MyfvSwiper", {
            slidesPerView: 2,
            spaceBetween: 10,
            speed: 1000,
            direction: 'vertical',
            navigation: {
                nextEl: ".MyfvNextMobile",
                prevEl: ".MyfvPrevMobile"
            },
        });

        $(".MyfvSt").on("click", (e) => {
            this.setWidget(e.target.checked);
        });
    }

    setWidget(onoff) {
        if (onoff) {
            $('#Myfvlist').show();
            $('#Myfvhelp').hide();
        } else {
            $('#Myfvlist').hide();
            $('#Myfvhelp').show();
        }
    }
}
